import SkillsTemplate from "@project/templates/skills/SkillsTemplate";
export default {
    key: "SKILLS",
    label: "Nos compétences",
    templateImage: "/template-competences.png",
    Component: SkillsTemplate,
    initialContents: [
        {
            children: [
                {
                    children: [
                        {
                            children: [],
                            key: "direction",
                            type: "RADIO_GROUP",
                            value: "vertical",
                        },
                        {
                            children: [],
                            key: "style",
                            type: "RADIO_GROUP",
                            value: "contained",
                        },
                        {
                            children: [],
                            key: "color",
                            type: "RADIO_GROUP",
                            value: "secondary",
                        },
                        {
                            children: [
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "Développement web",
                                            key: "title",
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            type: "INPUT",
                                                            value: "Notre approche",
                                                            key: "title",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "TEXT",
                                                            value: "%3Cp%3EOn%20con%C3%A7oit%20des%20applications%20web%20qui%20tiennent%20dans%20le%20temps%20%3A%20architecture%20typ%C3%A9e%20de%20bout%20en%20bout%2C%20tests%20automatis%C3%A9s%20et%20choix%20de%20stack%20assum%C3%A9s%20%26nbsp%3Bperformantes%20et%20durables%2C%20pas%20jetables.%3C%2Fp%3E%3Cp%3E%26nbsp%3B%3C%2Fp%3E%3Cp%3EPraesent%20consectetur%20elit%20et%20velit%20fermentum%20luctus.%20Class%20aptent%20taciti%20sociosqu%20ad%20litora%20torquent%20per%20conubia%20nostra%2C%20per%20inceptos%20himenaeos.%20Mauris%20diam%20est%2C%20rutrum%20a%20tempus%20vel%2C%20volutpat%20in%20sem.%3C%2Fp%3E%3Cp%3E%26nbsp%3B%3C%2Fp%3E%3Cp%3EAliquam%20id%20turpis%20viverra%2C%20scelerisque%20mi%20sed%2C%20egestas%20diam.%20In%20vehicula%20metus%20non%20bibendum%20pharetra.%20Proin%20sodales%20ultrices%20felis%20ut%20convallis.%20Aenean%20eu%20mauris%20eget%20quam%20scelerisque%20porta%20ut%20non%20ligula.%20Vestibulum%20cursus%20et%20augue%20ac%20lacinia.%20Proin%20sagittis%2C%20mauris%20vel%20lobortis%20viverra%2C%20nunc%20mauris%20elementum%20neque%2C%20nec%20accumsan%20neque%20turpis%20sed%20nulla.%3C%2Fp%3E",
                                                            key: "text",
                                                        },
                                                        {
                                                            children: [
                                                                {
                                                                    children: [],
                                                                    type: "FILE_IMAGE",
                                                                    key: "file",
                                                                    value: '{"name":"page_web_2.png","mimeType":"image/png","publicUrl":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.png","publicUrlBySize":{"300":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.300.png","600":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.600.png","1000":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.1000.png","1400":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.1400.png","1600":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.1600.png","2000":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.2000.png"},"url":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/8bd0be58-32b7-42bf-8320-bbea73b1db3e/fb5bb517-9cc5-49d4-a614-590b9088fa3b.png","alt":"","title":""}',
                                                                },
                                                                {
                                                                    children: [],
                                                                    type: "INPUT",
                                                                    value: "",
                                                                    key: "alt",
                                                                },
                                                                {
                                                                    children: [],
                                                                    type: "INPUT",
                                                                    value: "",
                                                                    key: "title",
                                                                },
                                                                {
                                                                    children: [],
                                                                    type: "SELECT",
                                                                    key: "position_verticale",
                                                                    value: "top",
                                                                },
                                                                {
                                                                    children: [],
                                                                    type: "SELECT",
                                                                    key: "position_horizontale",
                                                                    value: "center",
                                                                },
                                                                {
                                                                    children: [],
                                                                    type: "SELECT",
                                                                    key: "position_ajustement",
                                                                    value: "cover",
                                                                },
                                                                {
                                                                    children: [
                                                                        {
                                                                            children: [],
                                                                            type: "CHECKBOX",
                                                                            key: "activated",
                                                                            value: "false",
                                                                        },
                                                                        {
                                                                            children: [],
                                                                            type: "SLIDER",
                                                                            value: "1",
                                                                            key: "opacity",
                                                                        },
                                                                        {
                                                                            children: [],
                                                                            type: "SLIDER",
                                                                            value: "0",
                                                                            key: "blur",
                                                                        },
                                                                        {
                                                                            children: [],
                                                                            type: "SLIDER",
                                                                            value: "0",
                                                                            key: "grayscale",
                                                                        },
                                                                        {
                                                                            children: [],
                                                                            type: "SLIDER",
                                                                            value: "1",
                                                                            key: "brightness",
                                                                        },
                                                                        {
                                                                            children: [],
                                                                            type: "SLIDER",
                                                                            value: "1",
                                                                            key: "saturate",
                                                                        },
                                                                        {
                                                                            children: [],
                                                                            type: "SLIDER",
                                                                            value: "0",
                                                                            key: "sepia",
                                                                        },
                                                                    ],
                                                                    type: "IMAGE_FILTERS",
                                                                    key: "filters",
                                                                    value: "",
                                                                },
                                                            ],
                                                            type: "IMAGE",
                                                            key: "image",
                                                            value: "",
                                                        },
                                                        {
                                                            children: [
                                                                {
                                                                    children: [
                                                                        {
                                                                            children: [
                                                                                {
                                                                                    children: [
                                                                                        {
                                                                                            children: [],
                                                                                            type: "FILE_IMAGE",
                                                                                            key: "file",
                                                                                            value: '{"name":"react.png","mimeType":"image/png","publicUrl":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.png","publicUrlBySize":{"300":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.300.png","600":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.600.png","1000":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.1000.png","1400":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.1400.png","1600":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.1600.png","2000":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.2000.png"},"url":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/6c6de2b5-34d2-4836-9633-aa231485ca63/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.png","alt":"","title":""}',
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "INPUT",
                                                                                            value: "",
                                                                                            key: "alt",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "INPUT",
                                                                                            value: "",
                                                                                            key: "title",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "SELECT",
                                                                                            key: "position_verticale",
                                                                                            value: "top",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "SELECT",
                                                                                            key: "position_horizontale",
                                                                                            value: "center",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "SELECT",
                                                                                            key: "position_ajustement",
                                                                                            value: "cover",
                                                                                        },
                                                                                        {
                                                                                            children: [
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "CHECKBOX",
                                                                                                    key: "activated",
                                                                                                    value: "false",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "1",
                                                                                                    key: "opacity",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "0",
                                                                                                    key: "blur",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "0",
                                                                                                    key: "grayscale",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "1",
                                                                                                    key: "brightness",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "1",
                                                                                                    key: "saturate",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "0",
                                                                                                    key: "sepia",
                                                                                                },
                                                                                            ],
                                                                                            type: "IMAGE_FILTERS",
                                                                                            key: "filters",
                                                                                            value: "",
                                                                                        },
                                                                                    ],
                                                                                    type: "IMAGE",
                                                                                    key: "image",
                                                                                    value: "",
                                                                                },
                                                                                {
                                                                                    children: [],
                                                                                    type: "INPUT",
                                                                                    value: "React",
                                                                                    key: "title",
                                                                                },
                                                                            ],
                                                                            key: "items",
                                                                            type: "SKILL_BOX",
                                                                            value: "",
                                                                        },
                                                                        {
                                                                            children: [
                                                                                {
                                                                                    children: [
                                                                                        {
                                                                                            children: [],
                                                                                            type: "FILE_IMAGE",
                                                                                            key: "file",
                                                                                            value: '{"name":"react.png","mimeType":"image/png","publicUrl":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.png","publicUrlBySize":{"300":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.300.png","600":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.600.png","1000":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.1000.png","1400":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.1400.png","1600":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.1600.png","2000":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.2000.png"},"url":"http://localhost:8081/dalightged/2e277e7a-280b-41d1-9020-9df5a768e3b1/10cfa99f-c785-4abd-a5a4-fbcbd1f8b940/82ddbe47-2d07-4e19-9c1f-9320cdc8595d.png","alt":"image","title":"image"}',
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "INPUT",
                                                                                            value: "image",
                                                                                            key: "alt",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "INPUT",
                                                                                            value: "image",
                                                                                            key: "title",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "SELECT",
                                                                                            key: "position_verticale",
                                                                                            value: "top",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "SELECT",
                                                                                            key: "position_horizontale",
                                                                                            value: "center",
                                                                                        },
                                                                                        {
                                                                                            children: [],
                                                                                            type: "SELECT",
                                                                                            key: "position_ajustement",
                                                                                            value: "cover",
                                                                                        },
                                                                                        {
                                                                                            children: [
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "CHECKBOX",
                                                                                                    key: "activated",
                                                                                                    value: "false",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "1",
                                                                                                    key: "opacity",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "0",
                                                                                                    key: "blur",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "0",
                                                                                                    key: "grayscale",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "1",
                                                                                                    key: "brightness",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "1",
                                                                                                    key: "saturate",
                                                                                                },
                                                                                                {
                                                                                                    children: [],
                                                                                                    type: "SLIDER",
                                                                                                    value: "0",
                                                                                                    key: "sepia",
                                                                                                },
                                                                                            ],
                                                                                            type: "IMAGE_FILTERS",
                                                                                            key: "filters",
                                                                                            value: "",
                                                                                        },
                                                                                    ],
                                                                                    type: "IMAGE",
                                                                                    key: "image",
                                                                                    value: "",
                                                                                },
                                                                                {
                                                                                    children: [],
                                                                                    type: "INPUT",
                                                                                    value: "NodeJS",
                                                                                    key: "title",
                                                                                },
                                                                            ],
                                                                            key: "items",
                                                                            type: "SKILL_BOX",
                                                                            value: "",
                                                                        },
                                                                    ],
                                                                    key: "contentType",
                                                                    value: "SKILL_BOX",
                                                                },
                                                            ],
                                                            type: "DYNAMIC_LIST",
                                                            key: "dynamicList",
                                                            value: "",
                                                        },
                                                    ],
                                                    type: "SKILLS_TAB_PANEL",
                                                    key: "dynamicElements",
                                                    value: "",
                                                },
                                            ],
                                            type: "DYNAMIC",
                                            key: "children",
                                            value: "",
                                        },
                                    ],
                                    type: "TAB",
                                    key: "tabs",
                                    value: "",
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "Développement mobile",
                                            key: "title",
                                        },
                                        {
                                            children: [],
                                            type: "DYNAMIC",
                                            key: "children",
                                            value: "",
                                        },
                                    ],
                                    type: "TAB",
                                    key: "tabs",
                                    value: "",
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "Keycloak / IAM",
                                            key: "title",
                                        },
                                        {
                                            children: [],
                                            type: "DYNAMIC",
                                            key: "children",
                                            value: "",
                                        },
                                    ],
                                    type: "TAB",
                                    key: "tabs",
                                    value: "",
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "DevOps & Cloud",
                                            key: "title",
                                        },
                                        {
                                            children: [],
                                            type: "DYNAMIC",
                                            key: "children",
                                            value: "",
                                        },
                                    ],
                                    type: "TAB",
                                    key: "tabs",
                                    value: "",
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "Design UX / UI",
                                            key: "title",
                                        },
                                        {
                                            children: [],
                                            type: "DYNAMIC",
                                            key: "children",
                                            value: "",
                                        },
                                    ],
                                    type: "TAB",
                                    key: "tabs",
                                    value: "",
                                },
                                {
                                    children: [
                                        {
                                            children: [],
                                            type: "INPUT",
                                            value: "Maintenance & Run",
                                            key: "title",
                                        },
                                        {
                                            children: [],
                                            type: "DYNAMIC",
                                            key: "children",
                                            value: "",
                                        },
                                    ],
                                    type: "TAB",
                                    key: "tabs",
                                    value: "",
                                },
                            ],
                            type: "TABS",
                            key: "tabs",
                            value: "",
                        },
                    ],
                    type: "TABS_COMPONENT",
                    key: "dynamicElements",
                    value: "",
                },
                {
                    children: [
                        {
                            children: [],
                            type: "INPUT",
                            value: "NOTRE MÉTHODE",
                            key: "title",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "Livrer en continu, s'adapter en permanence",
                            key: "subtitle",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "Pas de grand plan figé six mois à l‘avance, on livre par lots de tâches terminées et vos priorités peuvent évoluer en cours de route",
                            key: "description",
                        },
                        {
                            children: [],
                            type: "FILE_IMAGE",
                            key: "image",
                            value: "",
                        },
                        {
                            children: [],
                            type: "COLOR",
                            key: "backgroundColor",
                            value: "",
                        },
                        {
                            children: [],
                            key: "style",
                            type: "RADIO_GROUP",
                            value: "text",
                        },
                        {
                            children: [],
                            key: "orientation",
                            type: "RADIO_GROUP",
                            value: "vertical",
                        },
                        {
                            children: [
                                {
                                    children: [
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Une livraison en continu",
                                                    key: "title",
                                                },
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Du fonctionnel à intervalles courts",
                                                    key: "description",
                                                },
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            type: "INPUT",
                                                            value: "",
                                                            key: "icon",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "SELECT",
                                                            key: "type",
                                                            value: "far",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "color",
                                                            value: "white",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "background",
                                                            value: "",
                                                        },
                                                    ],
                                                    type: "ICON",
                                                    value: "",
                                                    key: "icon",
                                                },
                                            ],
                                            key: "items",
                                            type: "DESCRIPTION_SECTION_ITEM",
                                            value: "",
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Des priorités qui s’ajustent",
                                                    key: "title",
                                                },
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Le flux suit vos besoins, les dates ne sont pas figées",
                                                    key: "description",
                                                },
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            type: "INPUT",
                                                            value: "",
                                                            key: "icon",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "SELECT",
                                                            key: "type",
                                                            value: "far",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "color",
                                                            value: "white",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "background",
                                                            value: "",
                                                        },
                                                    ],
                                                    type: "ICON",
                                                    value: "",
                                                    key: "icon",
                                                },
                                            ],
                                            key: "items",
                                            type: "DESCRIPTION_SECTION_ITEM",
                                            value: "",
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Du code à la prod, automisé",
                                                    key: "title",
                                                },
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "CI/CD : chaque incrément peut partir en production",
                                                    key: "description",
                                                },
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            type: "INPUT",
                                                            value: "",
                                                            key: "icon",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "SELECT",
                                                            key: "type",
                                                            value: "far",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "color",
                                                            value: "white",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "background",
                                                            value: "",
                                                        },
                                                    ],
                                                    type: "ICON",
                                                    value: "",
                                                    key: "icon",
                                                },
                                            ],
                                            key: "items",
                                            type: "DESCRIPTION_SECTION_ITEM",
                                            value: "",
                                        },
                                    ],
                                    key: "contentType",
                                    value: "DESCRIPTION_SECTION_ITEM",
                                },
                            ],
                            type: "DYNAMIC_LIST",
                            key: "dynamicList",
                            value: "",
                        },
                    ],
                    type: "DESCRIPTION_SECTION",
                    key: "dynamicElements",
                    value: "",
                },
                {
                    children: [
                        {
                            children: [],
                            type: "INPUT",
                            value: "INTELLIGENCE ARTIFICIELLE",
                            key: "title",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "Notre approche de l’IA",
                            key: "subtitle",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "On n'ajoute pas de l'IA pour faire moderne. On l'intègre là où elle crée de la valeur, au service de vos objectifs.",
                            key: "description",
                        },
                        {
                            children: [],
                            type: "FILE_IMAGE",
                            key: "image",
                            value: "",
                        },
                        {
                            children: [],
                            type: "COLOR_EXTENDED",
                            key: "backgroundColor",
                            value: "linear-gradient(86deg, #eaf1ff 11%, #bdd3ff 99%)",
                        },
                        {
                            children: [],
                            key: "style",
                            type: "RADIO_GROUP",
                            value: "card",
                        },
                        {
                            children: [],
                            key: "orientation",
                            type: "RADIO_GROUP",
                            value: "horizontal",
                        },
                        {
                            children: [
                                {
                                    children: [
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Du concret, pas du buzz",
                                                    key: "title",
                                                },
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Accélération du dev, recherche, tests et automatisation.",
                                                    key: "description",
                                                },
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            type: "INPUT",
                                                            value: "bullseye-arrow",
                                                            key: "icon",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "SELECT",
                                                            key: "type",
                                                            value: "fal",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "color",
                                                            value: "#0000FF",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "background",
                                                            value: "",
                                                        },
                                                    ],
                                                    type: "ICON",
                                                    value: "",
                                                    key: "icon",
                                                },
                                            ],
                                            key: "items",
                                            type: "DESCRIPTION_SECTION_ITEM",
                                            value: "",
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "L'humain garde la main",
                                                    key: "title",
                                                },
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "L'IA augmente nos équipes, elle ne décide pas à notre place.",
                                                    key: "description",
                                                },
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            type: "INPUT",
                                                            value: "user",
                                                            key: "icon",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "SELECT",
                                                            key: "type",
                                                            value: "fal",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "color",
                                                            value: "#0000FF",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "background",
                                                            value: "",
                                                        },
                                                    ],
                                                    type: "ICON",
                                                    value: "",
                                                    key: "icon",
                                                },
                                            ],
                                            key: "items",
                                            type: "DESCRIPTION_SECTION_ITEM",
                                            value: "",
                                        },
                                        {
                                            children: [
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Transparence & conformité",
                                                    key: "title",
                                                },
                                                {
                                                    children: [],
                                                    type: "INPUT",
                                                    value: "Des usages explicables, alignés RGPD et AI Act.",
                                                    key: "description",
                                                },
                                                {
                                                    children: [
                                                        {
                                                            children: [],
                                                            type: "INPUT",
                                                            value: "shield-check",
                                                            key: "icon",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "SELECT",
                                                            key: "type",
                                                            value: "fal",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "color",
                                                            value: "#0000FF",
                                                        },
                                                        {
                                                            children: [],
                                                            type: "COLOR",
                                                            key: "background",
                                                            value: "",
                                                        },
                                                    ],
                                                    type: "ICON",
                                                    value: "",
                                                    key: "icon",
                                                },
                                            ],
                                            key: "items",
                                            type: "DESCRIPTION_SECTION_ITEM",
                                            value: "",
                                        },
                                    ],
                                    key: "contentType",
                                    value: "DESCRIPTION_SECTION_ITEM",
                                },
                            ],
                            type: "DYNAMIC_LIST",
                            key: "dynamicList",
                            value: "",
                        },
                    ],
                    type: "DESCRIPTION_SECTION",
                    key: "dynamicElements",
                    value: "",
                },
                {
                    children: [
                        {
                            children: [],
                            type: "INPUT",
                            value: "Un projet à lancer, une équipe à mobiliser ?",
                            key: "title",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "Bénéficiez d'un accompagnement global porté par une équipe d'experts engagés",
                            key: "subtitle",
                        },
                        {
                            children: [
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "/contact",
                                    key: "url",
                                },
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "Nous contacter",
                                    key: "title",
                                },
                                {
                                    children: [],
                                    type: "PAGE",
                                    key: "page",
                                    value: "",
                                },
                                {
                                    children: [],
                                    type: "CHECKBOX",
                                    key: "external",
                                    value: "false",
                                },
                            ],
                            type: "LINK",
                            key: "link",
                            value: "",
                        },
                    ],
                    type: "CONTACT_BLOCK",
                    key: "dynamicElements",
                    value: "",
                },
            ],
            key: "dynamicPart",
            type: "DYNAMIC",
            value: "",
        },
    ],
};
